import type { FunctionComponent } from 'react';
import { compareStrings } from '@lib/utils';
import {
  EuiButton,
  EuiFlexGrid,
  EuiFlexItem,
  EuiSkeletonText,
  EuiSpacer,
} from '@elastic/eui';
import { usePersonGeoroles } from '@data/georoles';
import GeorolePanel from './georole-panel';
import type { Georole, Person } from '@domain/person';
import AddGeorole from './add-georole';

interface GeoroleSectionProps {
  person: Person;
}

const GeoroleSection: FunctionComponent<GeoroleSectionProps> = ({ person }) => {
  const { loading, georoles } = usePersonGeoroles(person.idnumber);

  if (loading) {
    return <EuiSkeletonText lines={3} />;
  }

  const sortedGeoroles = [...(georoles as Georole[])];
  sortedGeoroles.sort((a, b) =>
    compareStrings(a.roleName.toUpperCase(), b.roleName.toUpperCase())
  );

  return (
    <>
      {!person.authn?.suspended && (
        <AddGeorole
          person={person}
          button={<EuiButton iconType="plus">Add</EuiButton>}
          tooltip="Add new georole permissions"
        />
      )}
      <EuiSpacer size="s" />
      <EuiFlexGrid columns={3} gutterSize="s">
        {sortedGeoroles.map(georole => (
          <EuiFlexItem key={georole.roleName}>
            <GeorolePanel georole={georole} person={person} />
          </EuiFlexItem>
        ))}
      </EuiFlexGrid>
    </>
  );
};

export default GeoroleSection;
